import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './material.css'
import './../../css/nike.css'

import { startTimer, tickTimer } from './../../actions/socket'
import TeamName from './TeamName'
import theme from './../../themes/green/theme'

class Scoreboard extends Component {
  componentDidMount() {
    if (!this.props.match.timerStarted) {
      this.props.startTimer()
      this.runTime()
    }
  }

  runTime() {
    this.props.tickTimer()
    setTimeout(() => this.runTime(), 1000)
  }

  formatTime() {
    const { timer } = this.props.match
    let minutes = Math.floor(timer / 60),
      seconds = timer - 60 * minutes,
      strMinutes = '',
      strSeconds = ''
    if (minutes < 10) {
      strMinutes = '0'
    }
    strMinutes += minutes
    if (seconds < 10) {
      strSeconds = '0'
    }
    strSeconds += seconds
    return {
      strMinutes,
      strSeconds,
    }
  }

  render() {
    const { match } = this.props
    const { strMinutes, strSeconds } = this.formatTime()
    const teamSize = Math.max(
      match.home.name && match.home.name.length,
      match.away.name && match.away.name.length
    )
    return (
      <div>
        <div className="row valign-wrapper" style={{ height: '25vh' }}>
          <div className="col s3 center-align">
            <img
              src={theme.left_image.img}
              alt="Left"
              style={{ width: theme.left_image.width }}
            />
          </div>
          <div
            className="col s6 center-align time"
            style={{ fontSize: '25vh', lineHeight: 1 }}
          >
            <div className="col s5">{strMinutes}</div>
            <div className="col s2">:</div>
            <div className="col s5">{strSeconds}</div>
          </div>
          <div className="col s3 center-align">
            <img
              src={theme.right_image.img}
              alt="Right"
              style={{ width: theme.right_image.width }}
            />
          </div>
        </div>
        <div className="row valign-wrapper center-align stripe">
          <div className="col s5 home score">{match.home.score}</div>
          <div className="col s2" style={{ color: 'white' }}>
            <div className="row" style={{ fontSize: '15vh' }}>
              -
            </div>
            {!theme.fouls && (
              <div className="row valign-wrapper center-align">
                <img
                  src={theme.fouls_image}
                  alt="Scoreplay"
                  style={{ width: '100%' }}
                />
              </div>
            )}
            {theme.fouls && (
              <div className="row valign-wrapper" style={{ fontSize: '3vh' }}>
                <div className="col s4 fouls" style={{ textAlign: 'left' }}>
                  <span
                    className={
                      'fouls ' +
                      (match.home.fouls > 4
                        ? 'red-background'
                        : 'yellow-background')
                    }
                  >
                    {match.home.fouls}
                  </span>
                </div>
                <div className="col s4">Fouls</div>
                <div className="col s4 fouls" style={{ textAlign: 'right' }}>
                  <span
                    className={
                      'fouls ' +
                      (match.away.fouls > 4
                        ? 'red-background'
                        : 'blue-background')
                    }
                  >
                    {match.away.fouls}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="col s5 away score">{match.away.score}</div>
        </div>
        <div
          className="row valign-wrapper center-align"
          style={{ height: '10vh' }}
        >
          <div className="col s5 home">
            <TeamName teamSize={teamSize} name={match.home.name} />
          </div>
          <div className="col s2" />
          <div className="col s5 away">
            <TeamName teamSize={teamSize} name={match.away.name} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  match: state.match,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  tickTimer: () => dispatch(tickTimer()),
  startTimer: () => dispatch(startTimer()),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Scoreboard)
)
